import React from 'react';
import { Link } from 'react-router-dom';
import './EmptyState.css';

const EmptyState = ({
  icon = '📭',
  title = 'Nothing here yet',
  message = 'Get started by taking action below',
  actionText,
  actionLink,
  actionOnClick
}) => {
  return (
    <div className="empty-state">
      <div className="empty-state-icon">{icon}</div>
      <h3 className="empty-state-title">{title}</h3>
      <p className="empty-state-message">{message}</p>
      {actionText && (
        actionLink ? (
          <Link to={actionLink} className="btn btn-primary empty-state-btn">
            {actionText}
          </Link>
        ) : (
          <button onClick={actionOnClick} className="btn btn-primary empty-state-btn">
            {actionText}
          </button>
        )
      )}
    </div>
  );
};

export default EmptyState;
